import { appData, getApiKey } from 'optinmonster-js-library/src/utils';
import { disableDevCookie } from 'optinmonster-js-library/src/utils/apiKey';
import state from './state';
import { dismissKeys } from '../dashboard/store/state';

disableDevCookie();

const templatePaths = [
	'templates.activeType',
	// 'templates.activeTemplate',
	// 'templates.sort',
	// 'templates.search',
	'templates.filterOptions',
	// 'templates.filters',
];

const persistedPaths = ['visits', 'wizard', 'plugins'];
dismissKeys.forEach((k) => {
	persistedPaths.push(`dashboard.${k}`);
});

const noAuthPaths = ['user.onboarding', ...persistedPaths, ...templatePaths];

const authenticatedPaths = () => {
	const userKeys = { ...state.user };

	// Ejecting a few keys which we do not want/need persisted.
	// Don't persist `created`` as we use this to determine if user data should be fetched.
	delete userKeys.created;
	delete userKeys.updated;
	delete userKeys.email;
	delete userKeys.name;
	delete userKeys.firstName;
	delete userKeys.lastName;

	const userPaths = Object.keys(userKeys).map((k) => `user.${k}`);

	templatePaths.push('templates.permittedTypes');
	const paths = [...persistedPaths, ...templatePaths, ...userPaths];

	return paths;
};

export default {
	key: appData.key,
	paths: getApiKey() ? authenticatedPaths() : noAuthPaths,
};
